import {
    FormControl,
    IterateOptions
} from '../../../../components/FormUtilities'
import SelectTouch from '../../../../components/SelectTouch'
import { formInputPart, reqWarehouse } from '../../storage'
import useCompany from './useCompany'
import useGet from '../../../../hooks/useGet'
import Warehouse from '../../../../models/Warehouse'

function Company() {
    const { props, companies, handleChange } = useCompany()

    return (
        <FormControl label="Compañía" required>
            <SelectTouch
                {...props}
                onChange={handleChange}
                placeholder="Seleccionar compañía"
                label="Compañía"
                clear={false}
            >
                <IterateOptions data={companies} label="name" image="image" />
            </SelectTouch>
        </FormControl>
    )
}

function WarehouseField() {
    const { props } = formInputPart.useSelect('warehouse')
    const { data, loading } = useGet<Warehouse[]>(
        reqWarehouse.observer('/v5.6/apis/warehouses/company', true),
        []
    )

    return (
        <FormControl label="Almacén" required>
            <SelectTouch
                {...props}
                loading={loading}
                placeholder="Seleccionar almacén"
                label="Almacén"
            >
                <IterateOptions data={data.result} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

export default function Fields1() {
    return (
        <>
            <Company />
            <WarehouseField />
        </>
    )
}
